import { useState, useEffect } from 'react';
import { socket } from '../Entities/SocketService';
import api from '../Entities/ApiService';

/**
 * Hook customizado para rastrear usuários online em tempo real
 * @returns {Object} { onlineCount, onlineUsers, loading, error }
 */
export const useOnlineUsers = () => {
  const [onlineCount, setOnlineCount] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Buscar contagem inicial
    const fetchOnlineUsers = async () => {
      try {
        const response = await api.get('/audit/online-users');
        if (response.data.success) {
          setOnlineCount(response.data.data.count);
          setOnlineUsers(response.data.data.users);
        }
      } catch (err) {
        console.error('Erro ao buscar usuários online:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOnlineUsers();

    // Escutar atualizações em tempo real via Socket.IO
    const handleOnlineUsersUpdate = (data) => {
      setOnlineCount(data.count);
      setOnlineUsers(data.users || []);
    };

    socket.on('online_users_updated', handleOnlineUsersUpdate);

    // Cleanup
    return () => {
      socket.off('online_users_updated', handleOnlineUsersUpdate);
    };
  }, []);

  return { onlineCount, onlineUsers, loading, error };
};
